import { AuthenticatedUser, User } from './types';

export const isAuthenticatedUser = (user: User): user is AuthenticatedUser => {
  return 'token' in user;
};
